import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class SecurityIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return <SvgIcon {...this.props} viewBox="0 0 24 24" >
            <g fill="currentColor">
                <path d="M12,0c3.75,0,6.75,3,6.75,6.75v3C20.025,9.75,21,10.725,21,12v9.75c0,1.275-0.975,2.25-2.25,2.25H5.25
                    C3.975,24,3,23.025,3,21.75V12c0-1.275,0.975-2.25,2.25-2.25v-3C5.25,3,8.25,0,12,0z M4.5,12v9.75c0,0.45,0.3,0.75,0.75,0.75h13.5
                    c0.45,0,0.75-0.3,0.75-0.75V12c0-0.45-0.3-0.75-0.75-0.75H18H6H5.25C4.8,11.25,4.5,11.55,4.5,12z M17.25,9.75v-3
                    c0-2.925-2.325-5.25-5.25-5.25S6.75,3.825,6.75,6.75v3H17.25z"/>
                <path d="M12,13.5c1.275,0,2.25,0.975,2.25,2.25c0,0.975-0.6,1.8-1.5,2.1v1.65c0,0.45-0.3,0.75-0.75,0.75s-0.75-0.3-0.75-0.75v-1.65
                    c-0.9-0.3-1.5-1.125-1.5-2.1C9.75,14.475,10.725,13.5,12,13.5z M12,16.5c0.45,0,0.75-0.3,0.75-0.75S12.45,15,12,15
                    s-0.75,0.3-0.75,0.75S11.55,16.5,12,16.5z"/>
            </g>
        </SvgIcon>;
    }
}
